import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = { class: "lg:text-lg text-lg text-center lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_6 = { class: "relative bg-gray-300 rounded-lg shadow mt-2" }
const _hoisted_7 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_8 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_9 = { class: "font-medium text-curaduriaDark" }
const _hoisted_10 = { class: "md:hidden" }
const _hoisted_11 = { class: "hidden md:inline" }
const _hoisted_12 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_13 = {
  href: "https://minvivienda.gov.co/sites/default/files/normativa/1077%20-%202015.pdf",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_15 = { class: "relative bg-gray-300 rounded-lg shadow mt-2" }
const _hoisted_16 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_17 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_18 = { class: "font-medium text-curaduriaDark" }
const _hoisted_19 = { class: "md:hidden" }
const _hoisted_20 = { class: "hidden md:inline" }
const _hoisted_21 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_22 = {
  href: "https://www.monteria.gov.co/documentos/355/pot-vigente/",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_24 = { class: "relative bg-gray-300 rounded-lg shadow mt-2" }
const _hoisted_25 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_26 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_27 = { class: "font-medium text-curaduriaDark" }
const _hoisted_28 = { class: "md:hidden" }
const _hoisted_29 = { class: "hidden md:inline" }
const _hoisted_30 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_31 = {
  href: "https://drive.google.com/drive/folders/1h7a0lB83mrhbaxx-0YG6PA4a1fKx01LZ?usp=share_link",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_33 = { id: "udp" }
const _hoisted_34 = { class: "flex w-full justify-center font-medium text-curaduria text-2xl mt-6 sm:text-3xl" }
const _hoisted_35 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-4"
}
const _hoisted_36 = { class: "w-full flex items-start justify-between p-4 space-x-6" }
const _hoisted_37 = { class: "flex-1" }
const _hoisted_38 = { class: "flex items-center space-x-3" }
const _hoisted_39 = { class: "text-curaduria text-md font-medium truncate" }
const _hoisted_40 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_41 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_42 = { class: "w-0 flex-1 flex" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "ml-3" }
const _hoisted_45 = { id: "oriental" }
const _hoisted_46 = { class: "flex w-full justify-center font-medium text-curaduria text-2xl mt-4" }
const _hoisted_47 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-4"
}
const _hoisted_48 = { class: "w-full flex items-center justify-between p-6 space-x-6" }
const _hoisted_49 = { class: "flex-1" }
const _hoisted_50 = { class: "flex items-center space-x-3" }
const _hoisted_51 = { class: "text-curaduria text-md font-medium truncate" }
const _hoisted_52 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_53 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_54 = {
  class: "w-0 flex-1 flex",
  id: "buttonSeeId"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "ml-3" }
const _hoisted_57 = { class: "-ml-px w-0 flex-1 flex" }
const _hoisted_58 = ["href", "download"]
const _hoisted_59 = { class: "ml-3 text-curaduria" }
const _hoisted_60 = { id: "occidental" }
const _hoisted_61 = { class: "flex w-full justify-center text-curaduria font-medium text-2xl mt-4 py-2" }
const _hoisted_62 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-4"
}
const _hoisted_63 = { class: "w-full flex items-center justify-between p-6 space-x-6" }
const _hoisted_64 = { class: "flex-1" }
const _hoisted_65 = { class: "flex items-center space-x-3" }
const _hoisted_66 = { class: "text-curaduria text-md font-medium truncate" }
const _hoisted_67 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_68 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_69 = { class: "w-0 flex-1 flex" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "ml-3" }
const _hoisted_72 = { class: "-ml-px w-0 flex-1 flex" }
const _hoisted_73 = ["href", "download"]
const _hoisted_74 = { class: "ml-3 text-curaduria" }
const _hoisted_75 = { id: "sur" }
const _hoisted_76 = { class: "flex w-full justify-center text-curaduria font-medium text-2xl mt-4" }
const _hoisted_77 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-4"
}
const _hoisted_78 = { class: "w-full flex items-center justify-between p-6 space-x-6" }
const _hoisted_79 = { class: "flex-1" }
const _hoisted_80 = { class: "flex items-center space-x-3" }
const _hoisted_81 = { class: "text-curaduria text-md font-medium truncate" }
const _hoisted_82 = { class: "mt-1 text-gray-500 text-sm" }
const _hoisted_83 = { class: "-mt-px flex divide-x divide-gray-200" }
const _hoisted_84 = { class: "w-0 flex-1 flex" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "ml-3" }
const _hoisted_87 = { class: "-ml-px w-0 flex-1 flex" }
const _hoisted_88 = ["href", "download"]
const _hoisted_89 = { class: "ml-3 text-curaduria" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_EyeIcon = _resolveComponent("EyeIcon")
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")
  const _component_ModalPdf = _resolveComponent("ModalPdf")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("normativity.title")), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("normativity.des")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("normativity.decreto")), 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("normativity.decreto")), 1),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.$t("normativity.button")) + " ", 1),
                    _hoisted_14
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("normativity.pot")), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("normativity.pot")), 1),
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("a", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("normativity.button")) + " ", 1),
                    _hoisted_23
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("normativity.rules")), 1),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("normativity.rules")), 1),
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("a", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_ctx.$t("normativity.button")) + " ", 1),
                    _hoisted_32
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("normativity.header")), 1),
          _createElementVNode("ul", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.UDP, (document) => {
              return (_openBlock(), _createElementBlock("li", {
                key: document.title,
                class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("h3", _hoisted_39, _toDisplayString(document.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_40, _toDisplayString(document.description), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("a", {
                        href: `${document.pdfUrl}`,
                        target: "_blank",
                        class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 cursor-pointer"
                      }, [
                        _createVNode(_component_EyeIcon, {
                          class: "w-5 h-5 text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("normativity.buttonSee")), 1)
                      ], 8, _hoisted_43)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("normativity.oriental")), 1),
          _createElementVNode("ul", _hoisted_47, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bordeOriental, (document) => {
              return (_openBlock(), _createElementBlock("li", {
                key: document.title,
                class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
              }, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h3", _hoisted_51, _toDisplayString(document.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_52, _toDisplayString(document.description), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        onClick: $event => (_ctx.showModal(document.pdfUrl)),
                        class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_EyeIcon, {
                          class: "w-5 h-5 text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("normativity.buttonSee")), 1)
                      ], 8, _hoisted_55)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("a", {
                        href: document.pdfUrl,
                        download: document.description,
                        id: "pdfForDownload",
                        class: "relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_DownloadIcon, {
                          class: "w-5 h-5 text-curaduria",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("normativity.buttonDownload")), 1)
                      ], 8, _hoisted_58)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("normativity.occidental")), 1),
          _createElementVNode("ul", _hoisted_62, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bordeOccidental, (document) => {
              return (_openBlock(), _createElementBlock("li", {
                key: document.title,
                class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
              }, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("h3", _hoisted_66, _toDisplayString(document.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_67, _toDisplayString(document.description), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("button", {
                        onClick: $event => (_ctx.showModal(document.pdfUrl)),
                        class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_EyeIcon, {
                          class: "w-5 h-5 text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("normativity.buttonSee")), 1)
                      ], 8, _hoisted_70)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("a", {
                        href: document.pdfUrl,
                        download: document.title,
                        id: "pdfForDownload",
                        class: "relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_DownloadIcon, {
                          class: "w-5 h-5 text-curaduria",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("normativity.buttonDownload")), 1)
                      ], 8, _hoisted_73)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("normativity.sur")), 1),
          _createElementVNode("ul", _hoisted_77, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ciudadSur, (document) => {
              return (_openBlock(), _createElementBlock("li", {
                key: document.title,
                class: "col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
              }, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("h3", _hoisted_81, _toDisplayString(document.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_82, _toDisplayString(document.description), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("button", {
                        onClick: $event => (_ctx.showModal(document.pdfUrl)),
                        class: "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_EyeIcon, {
                          class: "w-5 h-5 text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t("normativity.buttonSee")), 1)
                      ], 8, _hoisted_85)
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("a", {
                        href: document.pdfUrl,
                        download: document.title,
                        id: "pdfForDownload",
                        class: "relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                      }, [
                        _createVNode(_component_DownloadIcon, {
                          class: "w-5 h-5 text-curaduria",
                          "aria-hidden": "true"
                        }),
                        _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t("normativity.buttonDownload")), 1)
                      ], 8, _hoisted_88)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_ModalPdf, {
        "modal-visible": _ctx.showModalPdf,
        pdfUrl: _ctx.pdfRoute,
        onClosed: _cache[0] || (_cache[0] = $event => (_ctx.closeModal())),
        onDownload: _cache[1] || (_cache[1] = $event => (_ctx.downloadItem()))
      }, null, 8, ["modal-visible", "pdfUrl"])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}